import { Control } from "react-hook-form";
import { FormInputNumber } from "../../../../components/ui/Input/FormInputNumber/FormInputNumber";
import { FormSelect } from "../../../../components/ui/Input/FormSelector/FormSelect";

import { validateFacilityNumber } from "../../../../utils/utils";
import { facilityNumberRules } from "../helpers/facilityValidation.helpers";
import { FacilityDraftFormValues, SourceSectionConfig, UnitOption } from "../types/facilityDrawer.types";
import FacilityYearInput from "./FacilityYearInput";
import { FormUnitInput } from "../../../../components/ui/Input/FormUnitInput/FormUnitInput";

interface VolumeRecordFieldsProps {
  control: Control<FacilityDraftFormValues>;
  index: number;
  config: SourceSectionConfig;
  sourceOptions: UnitOption[];
}

const VolumeRecordFields = ({ control, index, config, sourceOptions }: VolumeRecordFieldsProps) => (
  <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-4">
    <FormSelect
      control={control}
      name={`${config.key}.${index}.SourceId`}
      label="Source"
      required
      errorMessage="Source is required"
      options={sourceOptions}
      placeholder="Select source"
    />
    <FacilityYearInput control={control} name={`${config.key}.${index}.Year`} />
    {config.unitOptions ? (
      <FormUnitInput
        control={control}
        name={`${config.key}.${index}.Volumes`}
        label={config.volumeLabel}
        unitOptions={config.unitOptions}
        unitName={`${config.key}.${index}.UnitType`}
        validate={(v: any) => validateFacilityNumber(v)}
      />
    ) : (
      <FormInputNumber
        control={control}
        name={`${config.key}.${index}.Volumes`}
        label={config.volumeLabel}
        rules={facilityNumberRules}
        rightContentEnable
        rightContent={config.staticVolumeUnit}
      />
    )}
    <FormInputNumber
      control={control}
      name={`${config.key}.${index}.Price`}
      label="Price per unit"
      rules={facilityNumberRules}
      enableLimitedDecimal
      viewDecimalNumber={5}
    />
  </div>
);

export default VolumeRecordFields;
